import { gql } from "@apollo/client";

export const UPDATE_SADDLE = gql`
mutation updateSaddleFitSaddle($input: UpdateSaddleFitSaddleInput!) {
    updateSaddleFitSaddle(input: $input) {
      type
      brandName
      createdAt
      discipline
      newOrUsed
      price
      discount
      photo
      productTitle
      quantity
      size
      status
      description
      saddlefitSku
      score
      updatedAt
      variantId
      userId
      gallery
      pk
      scannedFiles
      sk
      measurements {
        barAngle
        gulletHeight
        gulletWidth
      }
      manufacturerMeasurements {
        barAngle
        gulletHeight
        gulletWidth
      }
    }
  }
`